import { render, staticRenderFns } from "./Bank.vue?vue&type=template&id=c574e906"
import script from "./Bank.vue?vue&type=script&lang=js"
export * from "./Bank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports